module.exports = __webpack_public_path__ + "media/assets/images/languages/es-457604b2963c734a69e49f106d371056.png";